export function startOfDay(d: Date | number): number {
  const dt = new Date(d);
  dt.setHours(0, 0, 0, 0);
  return dt.getTime();
}

export function addDays(ts: number, n: number): number {
  const d = new Date(ts);
  d.setDate(d.getDate() + n);
  return d.getTime();
}

export function formatHM(ts: number): string {
  const d = new Date(ts);
  return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
}

/**
 * «дд.мм.гг чч:мм–чч:мм» в поясе показа портала — для записи изменения времени игры
 * в историю. ts хранится в UTC-мс, tzShiftMs — тот же сдвиг показа, что у formatHM/
 * дашборда (add tzShiftMs → локальные геттеры). Возвращает undefined, если старта нет,
 * чтобы сравнение «было→стало» в истории не срабатывало на пустом времени.
 */
export function formatDateTimeRange(start?: number, end?: number, tzShiftMs = 0): string | undefined {
  if (start == null) return undefined;
  const pad = (n: number) => String(n).padStart(2, '0');
  const ds = new Date(start + tzShiftMs);
  const date = `${pad(ds.getDate())}.${pad(ds.getMonth() + 1)}.${String(ds.getFullYear()).slice(2)}`;
  return end != null ? `${date} ${formatHM(start + tzShiftMs)}–${formatHM(end + tzShiftMs)}` : `${date} ${formatHM(start + tzShiftMs)}`;
}

const MONTHS_SHORT = ['янв', 'фев', 'мар', 'апр', 'мая', 'июня', 'июля', 'авг', 'сен', 'окт', 'ноя', 'дек'];
const DOW_SHORT = ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'];

export function formatDateShort(ts: number): string {
  const d = new Date(ts);
  return `${d.getDate()} ${MONTHS_SHORT[d.getMonth()]}`;
}

export function formatDateLong(ts: number): string {
  const d = new Date(ts);
  return `${d.getDate()} ${MONTHS_SHORT[d.getMonth()]} ${d.getFullYear()}, ${DOW_SHORT[d.getDay()]}`;
}

export function formatMoney(amount: number | undefined, currency: 'KZT' | 'UZS' | 'AZN' | 'KGS'): string {
  if (amount == null) return '—';
  const symbol = currency === 'KZT' ? '₸' : currency === 'UZS' ? 'сум' : currency === 'KGS' ? 'сом' : '₼';
  return `${amount.toLocaleString('ru-RU')} ${symbol}`;
}

/** Локальное время с учётом сдвига филиала (для дашбордов) */
export function inBranchTz(ts: number, branchOffsetMin: number, localOffsetMin: number = -new Date().getTimezoneOffset()): number {
  return ts + (branchOffsetMin - localOffsetMin) * 60_000;
}
